"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearRecentSearch = clearRecentSearch;
exports.getAutoSuggestionSearch = getAutoSuggestionSearch;
exports.getFacilitySearch = getFacilitySearch;
exports.getRecentAndTrendingSearchData = getRecentAndTrendingSearchData;
exports.getSearchAutoSuggestions = getSearchAutoSuggestions;
exports.getSpecialitySearch = getSpecialitySearch;
exports.getTeleSearch = getTeleSearch;
exports.getTopTrendSearch = getTopTrendSearch;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getRecentAndTrendingSearchData(requestParams, tokenData) {
  const apiEndPoint = requestParams ? _ApiConst.GET_RECENT_SEARCH_AUTOSUGGEST + `?moduleType=${requestParams}` : _ApiConst.GET_RECENT_SEARCH_AUTOSUGGEST;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getSearchAutoSuggestions(data, tokenData) {
  const queryString = `?query=${data}`;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_SEARCH_AUTOSUGGESTIONS}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getAutoSuggestionSearch(requestParams, tokenData) {
  const queryString = `?q=${requestParams.q}`;
  const apiEndPoint = `${_ApiConst.TELE_SEARCH_AUTO_SUGGESTION}${_ApiConst.GET_AUTO_SUGGESTION_SEARCHES}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function clearRecentSearch(requestParams, tokenData) {
  const apiEndPoint = requestParams ? _ApiConst.RECENT_SEARCH_CLEAR + `?moduleType=${requestParams}` : _ApiConst.RECENT_SEARCH_CLEAR;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getTopTrendSearch(requestParams, tokenData) {
  const apiEndPoint = requestParams ? _ApiConst.GET_TRENDING_AUTOSUGGEST + `?moduleType=${requestParams}` : _ApiConst.GET_TRENDING_AUTOSUGGEST;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getTeleSearch(requestParams, tokenData) {
  let queryString = '';
  for (const key in requestParams) {
    if (queryString === '') {
      queryString = '?';
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.TELE_SEARCH}/api/search${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getFacilitySearch(requestParams, tokenData) {
  let queryString = '';
  for (const key in requestParams) {
    if (queryString === '') {
      queryString = '?';
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.TELE_SEARCH}/api/facility${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getSpecialitySearch(requestParams, tokenData) {
  let queryString = '';
  for (const key in requestParams) {
    if (queryString === '') {
      queryString = '?';
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.TELE_SEARCH}/api/speciality${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}